import { InjectionToken } from "@angular/core";
import { ICompanyRestClient } from "./i-company-rest.client";

export const companyRestClientInjectionToken: InjectionToken<ICompanyRestClient> = new InjectionToken<ICompanyRestClient>("digital-signage.user-dashboard.dashboard-web.CompanyRestClient");
